import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `ImportarDatos`, method: 'POST', body: value, token: token})
}
